<div class="snippet-container">
	<ng-container *ngIf="!editMode">
		<div
			[ngStyle]="{'background-image': 'url(' + snippet.bgImage + ')'}"
			[ngClass]="[snippet.paddingH, snippet.paddingV, snippet.backgroundColour]"
			[innerHTML]="snippet.content | safeHTML"></div>
		<div class="text-end mt-2">
			<button class="btn btn-sm btn-danger" (click)="deleteConfirm()">Remove</button>
            <button class="btn btn-sm btn-primary ms-2" (click)="viewImageLibrary('cms')">Image Library</button>
            <button class="btn btn-sm btn-danger ms-2" *ngIf="snippet.bgImage" (click)="imageDelete()">Remove image</button>

            <button class="btn btn-sm btn-primary ms-2" (click)="backgroundImage()">
                <span *ngIf="!snippet.bgImage">Background image</span>
                <span *ngIf="snippet.bgImage">Swap image</span>
            </button>
			<button class="btn btn-sm btn-primary ms-2" (click)="editSnippet()">Edit</button>
			<button class="btn btn-sm btn-primary ms-2" (click)="edit()">Edit text</button>
		</div>
	</ng-container>

	<ng-container *ngIf="editMode">
		<div class="m-3">
            <editor [(ngModel)]="snippet.content" [apiKey]="this.env.tinymceApiKey" [init]="tinyInit"></editor>
<!--			<quill-editor [modules]="config" [(ngModel)]="snippet.contents" [style]="{'height':'150px'}"></quill-editor>-->

		</div>
		<div class="text-end mt-2">
			<button class="btn btn-sm btn-primary" (click)="cancel()">Cancel</button>
			<button class="btn btn-sm btn-primary ms-2" (click)="save()">Save</button>
		</div>
	</ng-container>

</div>
<app-images *ngIf="showImageLibrary" [ownerId]="'cms'" [type]="imageLibraryType" [allowSelection]="false" (modalAction)="imageModalAction($event)" (imageSelected)="imageSelected($event)"></app-images>
<app-confirmation *ngIf="this.confirmationData.open" (complete)="confirmAction($event)" [data]="confirmationData"></app-confirmation>

<app-snippet-edit [snippet]="snippet" (modalAction)="editModalAction($event)" *ngIf="snippetEditModal"></app-snippet-edit>
<app-images *ngIf="showImageLibrary" [ownerId]="'cms'" [type]="imageLibraryType" [allowSelection]="false" (modalAction)="imageModalAction($event)" (imageSelected)="imageSelected($event)"></app-images>
